"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createValidationError = exports.validateProNumberFormat = exports.checkForDuplicate = exports.checkIfProNumberIsProvided = void 0;
const constants_1 = require("../constants");
const createValidationError = (errorType, metaData) => {
    return {
        errorType,
        ...(metaData && { metaData }),
    };
};
exports.createValidationError = createValidationError;
const checkIfProNumberIsProvided = (proNumber) => {
    if (!proNumber) {
        return createValidationError(constants_1.PRO_VALIDATION_ERROR_TYPES.REQUIRED);
    }
    return null;
};
exports.checkIfProNumberIsProvided = checkIfProNumberIsProvided;
const validateProNumberFormat = (proNumber) => {
    // Check if it's all numeric digits
    if (!/^\d+$/.test(proNumber)) {
        return createValidationError(constants_1.PRO_VALIDATION_ERROR_TYPES.INVALID_PRO_NUMBER);
    }
    // Check if proNumber is all zeros (e.g., "000", "0000")
    if (proNumber.match(/^([0])\1*$/)) {
        return createValidationError(constants_1.PRO_VALIDATION_ERROR_TYPES.INVALID_PRO_NUMBER);
    }
    return null;
};
exports.validateProNumberFormat = validateProNumberFormat;
const checkForDuplicate = (completedProList, proNumber, shipmentId) => {
    if (!completedProList || completedProList.length === 0) {
        return null;
    }
    const matchingPro = completedProList.find((pro) => Number(pro.proNumber) === Number(proNumber));
    if (matchingPro && matchingPro.shipmentId !== shipmentId) {
        return createValidationError(constants_1.PRO_VALIDATION_ERROR_TYPES.DUPLICATE_NUMBER);
    }
    return null;
};
exports.checkForDuplicate = checkForDuplicate;
